import script from "./StepPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./StepPaymentMethod.vue?vue&type=style&index=0&id=a133e4cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a133e4cc"]])

export default __exports__